import { Request } from "@/utils/request";
import { BaseList, BaseSearch } from "./base";

export const ApiLogin = (data) => {
    return new Request("POST", "/home/login", data).Fetch();
};

export const STATUS_ENABLE = 1;
export const STATUS_DISABLE = 2;
export const STATUS = {
    1: '正常',
    2: '禁用',
};

export const ROLE_ADMIN = 1;
export const ROLE_NORMAL = 2;
export const ROLE = {
    1: '管理员',
    2: '普通人员',
};

export class Admin {
    id          = 0;
    username    = '';
    password    = '';
    avatar      = '';
    routes      = '';
    role        = ROLE_NORMAL;
    status      = STATUS_ENABLE;
    createdAt   = '';
    updatedAt   = '';
    _role       = '';
    _status     = '';
    // newPassword = "";
    // oldPassword = "";
    constructor(id) {
        this.id = parseInt(id);
    }
    initByRequest() {
        return new Request("GET", "/admin/info", {}).AuthFetch().then((res) => {
            let x = res.data;
            this.id       = x.id;
            this.username = x.username;
            this.avatar   = x.avatar;
            this.role     = x.role;
            this.status   = x.status;
            this.status   = x.status;
            return this;
        });
    }
    // 更新自己
    update() {
        let data = {
            id      : this.id,
            username: this.username,
            avatar  : this.avatar,
        }
        return new Request("POST", "/admin/update", data).AuthFetch();
    }
    toggleStatus() {
        this.status = (this.status == STATUS_ENABLE ? STATUS_DISABLE : STATUS_ENABLE);
        return this;
    }
    // 更新其他人员
    save() {
        let data = {
            id      : this.id > 0 ? this.id : null,
            username: this.username,
            password: this.password.length > 0 ? this.password : null,
            avatar  : this.avatar.length > 0   ? this.avatar   : null,
            status  : this.status,
            routes  : this.routes,
        }
        return new Request("POST", "/admin/save", data).AuthFetch();
    }
}

export class AdminSearch extends BaseSearch {
    id       = null;
    status   = null;
    username = null;
    toParams() {
        let data = super.toParams();
        data.id = this.id;
        data.username = this.username;
        return data;
    }
}

export class AdminList extends BaseList {
    initByRequest() {
        if (this.search instanceof AdminSearch) {
            return new Request("GET", "/admin/search", this.search.toParams()).AuthFetch().then((data) => {
                this.total = data.data.total;
                this.list = data.data.list.map((x) => {
                    let item = new Admin(x.id);
                    item.username   = x.username;
                    item.avatar     = x.avatar;
                    item.routes     = x.routes;
                    item.status     = x.status;
                    item.role       = x.role;
                    item._role      = ROLE[x.role];
                    item._status    = STATUS[x.status];
                    item.createdAt  = x.created_at;
                    item.updatedAt  = x.updated_at;
                    return item;
                });
                return this;
            });
        }else{
            throw "this.search must instance of AdminSearch";
        }
    }
}
